
import verbs from "@/constants/verbs";

export const TENSES = {
  present: "Present",
  preterite: "Preterite",
  imperfect: "Imperfect",
  future: "Future",
  conditional: "Conditional",
  subjunctive: "Subjunctive Present",
};

export const TENSES_KEYS = Object.keys(TENSES);

export const PRONOUNS_EN_ES = [
  { en: "I", es: "yo" },
  { en: "You", es: "tú" },
  { en: "He/She", es: "él" },
  { en: "We", es: "nosotros" },
  { en: "You (plural)", es: "vosotros" },
  { en: "They", es: "ellos" },
];
export const PRONOUNS = {
  yo: "I / yo",
  tú: "You / tú",
  él: "He / él",
  // ella: "She / ella" ,
  nosotros: "We / nosotros",
  vosotros: "You (plural) / vosotros",
  // vosotras: "You (plural) / vosotras",
  ellos: "They / ellos",
  // ellas: "They (feminine) / ellas" ,
  // usted: "You (formal) / usted" ,
  // ustedes: "You (plural, formal) / ustedes"
};

export const PRONOUNS_KEYS = Object.keys(PRONOUNS);

export function buildGrammarFromVerbs(verbs) {
  const conjugations = new Set();

  for (const verb in verbs) {
    const verbData = verbs[verb];
    for (const tense in verbData.conjugations) {
      for (const pronoun in verbData.conjugations[tense]) {
        const conj = verbData.conjugations[tense][pronoun].conjugation;
        if (conj) {
          conjugations.add(conj.toLowerCase());
        }
      }
    }
  }

  // Build the JSGF grammar string
  const grammar = `#JSGF V1.0; grammar verbs; public <verb> = ${[...conjugations].join(' | ')};`;
  return grammar;
}
